import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsGlobe } from "react-icons/bs";
import GoodsDetailsdata from "./Table/GoodsDetailsdata";
import { useSelector, useDispatch } from "react-redux";

  
export default function GoodsInDetails() {
  const Navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showModalDelivery, setShowModalDelivery] = useState(false);
  const [showbuttons, setShowbuttons] = useState(false);

  const Permissions = useSelector((state) => state.user.userPermissions);
  const adddrawing = Permissions.find((o) => o.codename === "add_drawing");
  const viewdrawing = Permissions.find((o) => o.codename === "view_drawing");
  const Images = [];

  const _handleUploadImage = (event, type) => {
    const config = {
      // bucketName: "moodflik-portal",
      // dirName: "img" /* optional */,
      // region: "us-east-2",
      // accessKeyId: "AKIAWFNJSIDVAQA2KNEU",
      // secretAccessKey: "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",
    };
    const file = event.target.files[0];
    console.log("clicked", file);
    Images.push(file);
    console.log("Images", Images);
    // uploadFile(file, config)
    //   .then((data) => {
    //     // if (type == "cover") {
    //     //   setCover_photo_url(data.location.replace(/ /g, "%20"));
    //     // } else {
    //     //   setProfileImage(data.location.replace(/ /g, "%20"));
    //     // }
    //   })
    //   .catch((err) => console.error(err));
  };
  return (
    <div>
      <div>
        <h2 className="font-Montserrat text-xl font-bold text-black">
          Goods in Details
        </h2>
        <div className="border-b-2 border-blue-200 w-20"></div>
      </div>

      <div class="flex flex-wrap justify-center mt-2">
        <div className="w-full font-Montserrat flex-2 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ml-4">
          <div className="flex flex-wrap   pl-3 mt-1  rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-4 font-medium "> Supplier:</div>
              <div className="mt-4 mr-8 ml-2 text-gray-700 font-semibold">
                The Supplier's name
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Tracking ID:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                123512
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Delivery Company:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                Royal Mail
              </div>
            </div>
          </div>

          <div className="flex flex-row pl-3 space-x-3 mt-4">
            <BsGlobe size={24} color="#1F78B4" />
            <p className="font-Roboto text-base text-gray-600">
              www.website.com
            </p>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Date of Purchase
              </div>
            </div>
          </div>
          <div
            className="flex mt-2 flex-row space-x-2
px-3 py-1 uppercase leading-wide text-gray-700 text-sm font-medium"
          >
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 16.6667H13.3333V13.3333H16.6667V16.6667ZM11.6667 8.33333H8.33333V11.6667H11.6667V8.33333ZM16.6667 8.33333H13.3333V11.6667H16.6667V8.33333ZM6.66667 13.3333H3.33333V16.6667H6.66667V13.3333ZM11.6667 13.3333H8.33333V16.6667H11.6667V13.3333ZM6.66667 8.33333H3.33333V11.6667H6.66667V8.33333ZM20 1.66667V20H0V1.66667H2.5V2.5C2.5 3.41917 3.2475 4.16667 4.16667 4.16667C5.08583 4.16667 5.83333 3.41917 5.83333 2.5V1.66667H14.1667V2.5C14.1667 3.41917 14.9142 4.16667 15.8333 4.16667C16.7525 4.16667 17.5 3.41917 17.5 2.5V1.66667H20ZM18.3333 6.66667H1.66667V18.3333H18.3333V6.66667ZM16.6667 0.833333C16.6667 0.373333 16.2942 0 15.8333 0C15.3725 0 15 0.373333 15 0.833333V2.5C15 2.96 15.3725 3.33333 15.8333 3.33333C16.2942 3.33333 16.6667 2.96 16.6667 2.5V0.833333ZM5 2.5C5 2.96 4.6275 3.33333 4.16667 3.33333C3.70583 3.33333 3.33333 2.96 3.33333 2.5V0.833333C3.33333 0.373333 3.70583 0 4.16667 0C4.6275 0 5 0.373333 5 0.833333V2.5Z"
                  fill="black"
                  fill-opacity="0.8"
                />
              </svg>
            </div>
            <div className="ml-2">26-oct-2021</div>
            <div>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="black"
                  fill-opacity="0.7"
                />
              </svg>
            </div>
            <div className="ml-2 -mt-0.5">3: 45: pm</div>
          </div>

          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Date of Arrival
              </div>
            </div>
          </div>
          <div
            className="flex mt-2 flex-row space-x-2
px-3 py-1 uppercase leading-wide text-gray-700 text-sm font-medium"
          >
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 16.6667H13.3333V13.3333H16.6667V16.6667ZM11.6667 8.33333H8.33333V11.6667H11.6667V8.33333ZM16.6667 8.33333H13.3333V11.6667H16.6667V8.33333ZM6.66667 13.3333H3.33333V16.6667H6.66667V13.3333ZM11.6667 13.3333H8.33333V16.6667H11.6667V13.3333ZM6.66667 8.33333H3.33333V11.6667H6.66667V8.33333ZM20 1.66667V20H0V1.66667H2.5V2.5C2.5 3.41917 3.2475 4.16667 4.16667 4.16667C5.08583 4.16667 5.83333 3.41917 5.83333 2.5V1.66667H14.1667V2.5C14.1667 3.41917 14.9142 4.16667 15.8333 4.16667C16.7525 4.16667 17.5 3.41917 17.5 2.5V1.66667H20ZM18.3333 6.66667H1.66667V18.3333H18.3333V6.66667ZM16.6667 0.833333C16.6667 0.373333 16.2942 0 15.8333 0C15.3725 0 15 0.373333 15 0.833333V2.5C15 2.96 15.3725 3.33333 15.8333 3.33333C16.2942 3.33333 16.6667 2.96 16.6667 2.5V0.833333ZM5 2.5C5 2.96 4.6275 3.33333 4.16667 3.33333C3.70583 3.33333 3.33333 2.96 3.33333 2.5V0.833333C3.33333 0.373333 3.70583 0 4.16667 0C4.6275 0 5 0.373333 5 0.833333V2.5Z"
                  fill="black"
                  fill-opacity="0.8"
                />
              </svg>
            </div>
            <div className="ml-2">26-oct-2021</div>
            <div>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="black"
                  fill-opacity="0.7"
                />
              </svg>
            </div>
            <div className="ml-2 -mt-0.5">3: 45: pm</div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium "> Status:</div>
              <div className="mt-2 mr-8 ml-2 text-red-400 font-medium">
                Delivered
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <GoodsDetailsdata />
        </div>
      </div>
{showbuttons  ? (
      <div className="flex flex-row justify-center my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat space-x-128  font-medium text-lg"
          onClick={() => setShowbuttons(false)}
        >
          Cancel
        </button>
       
        <button
          type="submit"
          className="text-white ml-auto space-x-128  bg-green-100 hover:bg-green-200 font-Montserrat font-semibold  place-content-center rounded-md py-1 px-8 flex flex-shrink-1 "
            
        >
          Print Barcode
        </button>
        
      </div> ) :  <div className="flex flex-row justify-center my-10">
      <button
        type="button"
        className="text-red-600 font-Montserrat space-x-128  font-medium text-lg"
        onClick={() => Navigate("/dashboard/warehouse/goodsInout")}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="text-green-100 ml-auto mr-4 space-x-128  bg-transparent hover:bg-green-100 hover:text-white font-Montserrat font-semibold  place-content-center rounded-md py-1 px-8 flex flex-shrink-1 "
        onClick={() => {
          setShowModal(true);
        }}
      >
        Reject Delivery
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
              {/*content*/}
              <div
                className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                style={{ width: "40vw" }}
              >
                {/*header*/}
                <button
                  type="button"
                  class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                  onClick={() => setShowModal(false)}
                >
                  <svg
                    className="mr-1"
                    width="12"
                    height="13"
                    viewBox="0 0 12 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1.5L11 11.5M1 11.5L11 1.5"
                      stroke="#E40000"
                      stroke-opacity="0.6"
                      stroke-width="2"
                    />
                  </svg>
                  Cancel
                </button>
                <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Report a Problem
                  </h2>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/*body*/}
                <div className="relative px-6 flex-auto">
                  <div className="flex  font-Montserrat">
                    <div class=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
                    <p className="text-blue-200 font-Montserrat">Details</p>
                  </div>
                  <form className="">
                    <div class="relative z-0 w-3/4 mb-1 group">
                      <input
                        type="text"
                        name="Name"
                        class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                        placeholder="Name of Issue "
                        required
                      />
                    </div>
                    <div class="relative z-0 w-3/4 mb-1 group">
                      <input
                        type="text"
                        name="description"
                        class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                        placeholder="Description "
                        required
                      />
                    </div>
                  </form>
                  {!viewdrawing ===undefined ||  viewdrawing?.codename ===
                    "view_drawing" ? (
                  <>
                  <h2 class=" ">
                    <div
                      class="
    relative
    flex
    items-center
    w-full
    py-4
    font-Montserrat
    text-base text-blue-200 text-left
    bg-transparent
    border-0
    rounded-none
    transition
    focus:outline-none
    "
                    >
                      <svg
                        className="mr-2 hover:rotate-180"
                        width="15"
                        height="10"
                        viewBox="0 0 15 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
                          stroke="#1F78B4"
                          stroke-width="2"
                        />
                      </svg>{" "}
                      Images
                    </div>
                  </h2>
                  <div className="flex ">
                    <div className=" space-x-15 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                      <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                        <div className="text-center h-16 "></div>
                      </div>
                    </div>
                    <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                      <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                        <div className="text-center h-16 "></div>
                      </div>
                    </div>
                    <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                      <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                        <div className="text-center h-16 "></div>
                      </div>
                    </div>
                    <div className=" space-x-15 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat">
                      <div className="flex flex-col bg-gray-200 shadow-lg rounded-lg border-cyan-100 border-1 items-center py-4 font-Montserrat">
                        <div className="text-center h-16 "></div>
                      </div>
                    </div>
                  </div>
                  </>
                  ) : null}
                {!adddrawing ===undefined ||  adddrawing?.codename ===
                            "add_drawing" ? (
                              <div className="flex flex-row mt-8 place-content-center bg-blue-50 border-2 border-blue-200 py-2 space-x-2">
                              <label
                                for="file-input-cover"
                                className="flex flex-wrap cursor-pointer custom-file-upload text-blue-200 font-semibold text-lg"
                              >
                                <svg
                                  width="25"
                                  height="25"
                                  viewBox="0 0 25 25"
                                  className="mr-2"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle cx="12.5" cy="12.5" r="12.5" fill="#1F78B4" />
                                  <path
                                    d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                                    stroke="white"
                                    stroke-width="1.66667"
                                  />
                                </svg>{" "}
                                Upload Images
                              </label>
                              <input
                                id="file-input-cover"
                                type="file"
                                className="text-blue-200 font-semibold text-lg hidden"
                                name="profile"
                                accept="image/jpeg,image/jpg"
                                onChange={(e) => _handleUploadImage(e, "cover")}
                              />
                              
                            </div>
                  ) : null}

                  <div className="flex  font-Montserrat">
                    <div class=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
                    <p className="text-blue-200 font-Montserrat">Status</p>
                  </div>
                  <form>
                    <div class="relative z-0 w-3/4  group">
                      <select
                        id="status"
                        class=" border mt-8 border-gray-200 text-gray-400 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3"
                        placeholder=" "
                        required
                      >
                        <option selected>Report to Supplier</option>
                        <option value="US">Damaged</option>
                        <option value="CA">Repaired</option>
                        <option value="FR">Faulty</option>
                        <option value="DE">Delayed</option>
                      </select>
                    </div>
                  </form>
                </div>
                {/*footer*/}
                <div className="flex px-6 pb-4 rounded-b">
                  <div className="float-left">
                    <button
                      className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="float-right ml-auto">
                    <button
                      className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Report Issue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      <button
        type="submit"
        className="text-white  space-x-128  bg-green-100 hover:bg-green-200 font-Montserrat font-semibold  place-content-center rounded-md py-1 px-8 flex flex-shrink-1 "
        onClick={() => {
          setShowModalDelivery(true);
        }}
      >
        Approve Delivery
      </button>
      {showModalDelivery ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative my-auto mx-auto lg:max-w-xl md:max-w-lg">
                {/*content*/}
                <div
                  className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
                  style={{ width: "55vw" }}
                >
                  {/*header*/}
                  <button
                    type="button"
                    class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                    onClick={() => setShowModalDelivery(false)}
                  >
                    <svg
                      className="mr-1"
                      width="12"
                      height="13"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L11 11.5M1 11.5L11 1.5"
                        stroke="#E40000"
                        stroke-opacity="0.6"
                        stroke-width="2"
                      />
                    </svg>
                    Cancel
                  </button>
                  <div className=" ml-3 flex items-start justify-between -mt-8 w-fit rounded-t">
                    <h2 className="font-Montserrat text-xl font-medium text-black">
                      check-in and approval
                    </h2>
                    <button
                      className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setShowModalDelivery(false)}
                    >
                      <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>

                  {/*body*/}
                  <div className="relative p-6 flex-auto">
                   
                    <h2 className="font-Montserrat text-sm font-medium text-gray-50">
                    Have the items been the QC Checked?
                  </h2>
                    <form className="">
                    <div className="flex mt-2">
                        <input
                          type="checkbox"
                          className="border-2 w-fit bg-default rounded-md  py-2.5 font-medium relative block px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat"
                          placeholder="Delivery Date"
                        ></input>
                        <label className="text-sm font-medium font-Montserrat text-black">
                          <span className="ml-2">
                            The items have been checked
                          </span>
                        </label>
                      </div>
                      <div class="relative z-0 w-3/4 mb-1 group">
                        <input
                          type="text"
                          name="Notes"
                          class="block py-2.5 px-0 w-full placeholder-gray-100 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
                          placeholder="Notes"
                          required
                        />
                      </div>
                    
                    </form>

                  </div>
                  {/*footer*/}
                  <div className="flex p-6  rounded-b">
                    <div className="float-left">
                      <button
                        className="text-red-500  background-transparent text-lg px-6 py-2  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => setShowModalDelivery(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="float-right ml-auto mr-4">
                    <button
                      className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => {setShowModalDelivery(false); Navigate("/dashboard/warehouse/printscan")} }
                    >
                      Print Barcode
                    </button>
                  </div>
                    <div className="">
                      <button
                        className="bg-green-100 hover:bg-green-200 text-white active:bg-emerald-600 font-bold  text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => {setShowModalDelivery(false); setShowbuttons(true)}}
                      >
                        Approve Delivery
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
    </div>}
    </div>
  );
}
